module.exports = __webpack_public_path__ + "static/media/pic_ka_bj.bc290237.png";